(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orientation-quiz"] && !Shopify.designMode) return;
  try {
    
$(document).on('readystatechange', initMouthContent);
  
function fetchMetaObjects() {
  // Fetch every remaining mouthpieces-values page (pagination is capped at 50 items
  // per Shopify paginate call), one at a time, and keep going until no
  // "load more" link is left in the DOM (chasing links added by pages we've
  // already fetched too). Without this loop, only the first extra page ever
  // loaded, silently dropping any instrument whose mouthpieces fell on page 3+.
  var $link = $('[data-pages-values-url]').first();
  if (!$link.length) {
    return;
  }
  if (debugMode) console.log('%c' + $link[0], consolesecondary);
  var url = $link.attr('data-pages-values-url');
  $link.remove();
  $.ajax({
    url: url,
    success: function(output) {
      var content = $(output).find(".shopify-section-mouthpieces-values");
      if (content.length) {
        $('#orientation-quiz__section').append(content);
      }
      fetchMetaObjects();
    },
    error: function() {
      if (debugMode) console.warn('%cfetchMetaObjects: failed to load a mouthpieces page', consolesecondary);
    }
  });
}

var debugMode = document.location.href.match(/debugQuiz=1/);
var consoleprimary = "background: white;color:black;font-weight:bolder;padding: 2px 4px;font-size:14px;";
var consolesecondary = "background:#413c26;color:#7ab1f3;font-weight:bold;padding: 2px 4px;font-size:13px;";
var result = {
    all_matches: [],
    first_match : {name : '',featured_image : '', desc_image : '' ,  product_url : '', match_percent : -1 , distance : 0, tone: '', power: ''},
    second_match : {name : '',featured_image : '', desc_image : '' ,  product_url : '', match_percent : -1 , distance : 0, tone: '', power: ''},
    third_match : {name : '',featured_image : '', desc_image : '' ,  product_url : '', match_percent : -1 , distance : 0, tone: '', power: ''}
};
function initMouthContent() {
  fetchMetaObjects();
  var at = 0;
  var ap = 0;
  var bt = 0;
  var bp = 0;
  var ct = 0;
  var cp = 0;
  var choices = '';
  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  
  function eraseCookie(name) {   
      // document.cookie = name+'=; Max-Age=-99999999;';  
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  
  var customerIsLogged = $('#customerLogged').val() == 'true';
  if (debugMode) console.log('%ccustomer is Logged ? ************************* ' + customerIsLogged, consolesecondary)
  if(localStorage.logged_in_for_result == "true") {
      localStorage.logged_in_for_result = "false";
    if (customerIsLogged === true) {
      $('.section__header').hide();
      $('.step-1').hide();
      $('.step-3').show();
    } else {
      $('.step-5').show();
    }
  }else{
    $('.section__header').show();
    $('.step-1').show();
  }
  const cookieResult = getCookie('o_result');
  if (debugMode) console.log('%cinitContentMouthPiece - cookieResult: ' + cookieResult, consolesecondary);
  if(cookieResult != null && customerIsLogged === true){
    result = JSON.parse(getCookie('o_result'));

    var size = 0;
    const selectedMouthPiece = localStorage.selected_col_item;
    $('.selected_col_item').attr('data-mouthpiece-type', selectedMouthPiece);
    if (debugMode) console.log('%cinitContentMouthPiece - selectedMouthPiece:' + selectedMouthPiece, consolesecondary);
    eraseCookie('mouthpiece_selected');
    
    $('.mouthpieces-questions').each(function(index) {
      if(selectedMouthPiece == $(this).data('for')){
        size = size + 1;
      }
    });
    if (debugMode) console.log('%csize: ' + size, '%cskip_count :' + parseInt(getCookie('skip_count')), consolesecondary, consolesecondary)
    if( size == parseInt(getCookie('skip_count')) ){
      if (debugMode) console.log('%cskip count if : ' + parseInt(getCookie('skip_count')), consolesecondary)
      
      $('.section__header').hide();
      $('.step-1').hide();
      $('.orientation-quiz-section .container').addClass('container--small');
      $('.orientation-quiz-section .container').removeClass('container--medium');
      $('.step-3').hide();
      $('.step-4').show();
    }else{
        if (debugMode) console.log('%cskip count else: ' + parseInt(getCookie('skip_count')), consolesecondary);
    
        $('.match-percent-1').text((result.first_match.match_percent * 100).toFixed(0)+'%');
        $('.match-artist-1').text(result.first_match.name);
        $('.match-image-1').attr('src',result.first_match.featured_image);
        $('.match-desc-image-1').attr('src',result.first_match.desc_image);
        $('.match-info-btn-1').attr('href',result.first_match.product_url);

        $('.match-percent-2').text((result.second_match.match_percent * 100).toFixed(0)+'%');
        $('.match-artist-2').text(result.second_match.name);
        $('.match-image-2').attr('src',result.second_match.featured_image);
        $('.match-desc-image-2').attr('src',result.second_match.desc_image);
        $('.match-info-btn-2').attr('href',result.second_match.product_url);
        if((result.second_match.match_percent * 100)<70){
            $('.match-result-item-2').hide();
            $('.match-results').attr('data-matchresult',parseInt($('.match-results').attr('data-matchresult'))-1);
        }

        $('.match-percent-3').text((result.third_match.match_percent * 100).toFixed(0)+'%');
        $('.match-artist-3').text(result.third_match.name);
        $('.match-image-3').attr('src',result.third_match.featured_image);
        $('.match-desc-image-3').attr('src',result.third_match.desc_image);
        $('.match-info-btn-3').attr('href',result.third_match.product_url);
        if((result.third_match.match_percent * 100)<70){
            $('.match-result-item-3').hide();
            $('.match-results').attr('data-matchresult',parseInt($('.match-results').attr('data-matchresult'))-1);
        }
      
        $('.mouthpieces-questions').each(function(index) {
            if(selectedMouthPiece == $(this).data('for')){
                var handleQ1 = $(this).data('question1-system-handle');
                var toneQ1 = $(this).data('question1-tone');
                var powerQ1 = $(this).data('question1-power');
                var audioQ1 = $(this).data('question1-audio');
                var handleQ1 = $(this).data('question1-system-handle');
                var nameQ1 = $(this).data('question1-name').replace(' (' + selectedMouthPiece + ')', '');
                if($('.listened-excerpts-wrap .' + handleQ1).length <= 0 ){
                  $('.listened-excerpts-wrap').append(`<div class="listened-audio-item-wrap"><div class="player"><input type="checkbox" id="result_play_1st_${index}" 
                  class="play-pause" data-controlfor="result_audio_1st_${index}"> <label  class="custom_play_icon" for="result_play_1st_${index}"> 
                  <div class="play_pause_btn "> <div class="bar1"></div> <div class="bar2"></div> </div> </label><audio id="result_audio_1st_${index}" 
                  class="${handleQ1}" controls> <source class="listened-audio-item" 
                  src="${audioQ1}"> </audio>
                  <a class="custom_play_button">play / pause</a></div><div class="listened-audio-info">
                  <p>${nameQ1}</p>
                  <span>Tone : ${toneQ1} </span>
                  <span>Power : ${powerQ1} </span></div></div>`)
                }
                var handleQ2 = $(this).data('question2-system-handle');
                var toneQ2 = $(this).data('question2-tone');
                var powerQ2 = $(this).data('question2-power');
                var audioQ2 = $(this).data('question2-audio');
                var handleQ2 = $(this).data('question2-system-handle');
                var nameQ2 = $(this).data('question2-name').replace(' (' + selectedMouthPiece + ')', '');
                if($('.listened-excerpts-wrap .' + handleQ2).length <= 0 ){
                  $('.listened-excerpts-wrap').append(`<div class="listened-audio-item-wrap"><div class="player"><input type="checkbox" id="result_play_2nd_${index}" 
                  class="play-pause" data-controlfor="result_audio_2nd_${index}"> <label  class="custom_play_icon" for="result_play_2nd_${index}"> 
                  <div class="play_pause_btn "> <div class="bar1"></div> <div class="bar2"></div> </div> </label><audio id="result_audio_2nd_${index}" 
                  class="${handleQ2}" controls> <source class="listened-audio-item" 
                  src="${audioQ2}"> </audio>
                  <a class="custom_play_button">play / pause</a></div><div class="listened-audio-info">
                  <p>${nameQ2}</p>
                  <span>Tone : ${toneQ2} </span>
                  <span>Power : ${powerQ2} </span></div></div>`)
                }
            }
        });
        $('.section__header').hide();
        $('.step-1').hide();
        $('.orientation-quiz-section .container').removeClass('container--small');
        $('.orientation-quiz-section .container').addClass('container--medium');
        $('.step-3').show();
      }  
     eraseCookie('o_result'); 
  }
  var question_index = 1;
  var tone_arr = [];
  var power_arr = [];
  if (debugMode) console.log('%cscript loaded', consolesecondary);
  
  function getMean(array){
    var mean = 0;
    array.forEach(function(item){
      mean += item;
    });
    mean = mean / array.length;
    return mean;
  }
  function get_distance(x1,y1,x2,y2){
      return Math.sqrt(Math.pow((x2-x1),2) + Math.pow((y2-y1),2) );
  }
  
  function push_distances(name,distance,featured_image_url,desc_image_url,product_url, tone, power){
      var currentItem = {
        distance: distance,
        name: name,
        featured_image: featured_image_url,
        desc_image: desc_image_url,
        product_url: product_url,
        tone: tone,
        power: power,
      };
      var insertedIn = -1;
      var matchesLenght = result.all_matches.length;
      if (debugMode) console.log(`%cMatches lenght before : ${matchesLenght}`, consolesecondary)
      if (matchesLenght > 0) {
        var currentKey = 0;
        for (currentKey = 0; currentKey < matchesLenght; currentKey++) {
          if (typeof(result.all_matches[currentKey]) !== 'undefined' && result.all_matches[currentKey].name === name) {
              if (debugMode) console.log(`%cResult already in matches (ignored) ! ${name} ${distance}`, consolesecondary)
              return true;
          }
        }
        for (currentKey = 0; currentKey < matchesLenght; currentKey++) {
          if (typeof(result.all_matches[currentKey]) !== 'undefined' && result.all_matches[currentKey].distance > distance) {
            if (debugMode) console.log(`%cInserted in position ${currentKey} - match distance : ${result.all_matches[currentKey].distance} - ${name} ${distance}`, consolesecondary)
            insertedIn = currentKey;
            result.all_matches.splice(currentKey, 0, currentItem);
            break;
          }
        }
      }
      if (insertedIn === -1) {
        var lastDistance = result.all_matches[matchesLenght - 1] ? result.all_matches[matchesLenght - 1].distance : 'No items at this time !';
        if (debugMode) console.log(`%cInserted in end of matches - match distance last : ${lastDistance} - ${name} ${distance}`, consolesecondary)
        result.all_matches.push(currentItem);
      }
      if (result.all_matches[0]) {
        result.first_match = result.all_matches[0];
      }
      if (result.all_matches[1]) {
        result.second_match = result.all_matches[1];
      }
      if (result.all_matches[2]) {
        result.third_match = result.all_matches[2];
      }
      if (debugMode) console.log(`%cdistances first_match - second_match - third_match : ${result.first_match.distance} - ${result.second_match.distance} - ${result.third_match.distance}`, consolesecondary)
      if (debugMode) console.log(`%cMatches calculation at this time: ${result.all_matches.length}`, consolesecondary)
  }  
  
  function get_closest_mouthpieces(pt,pp){
    var selectedMouthPiece = $('.selected_col_item').attr('data-mouthpiece-type');
    $('.mouthpieces-values').each(function(index) {
      if($(this).data('for') == selectedMouthPiece) {
        var tone = $(this).data('tone');
        var power = $(this).data('power');
        var name = $(this).data('name');
        var featured_image = $(this).data('featured_image');
        var description_image = $(this).data('description_image');
        var product = $(this).data('product');
        var distance = get_distance(parseFloat(tone), parseFloat(power), pt, pp);   
        if (debugMode) console.log(`%c *********** START name: ${name}`, consoleprimary);
        push_distances(name, distance,featured_image,description_image, product, tone, power);     
        if (debugMode) console.log(`%ctone: ${tone} - power: ${power} - distance: ${distance}`, consolesecondary);
        if (debugMode) console.log(`%c ************* END name: ${name}`, consoleprimary);
      }
    });
  }
    
  function get_match_rate() {
    var selectedMouthPiece = $('.selected_col_item').attr('data-mouthpiece-type');
    let params = null;
    $('#mouthpieces-calculation span').each(function(index) {
      var calculationName = $(this).data('calculation-name');
      if($('.selected_col_item').attr('data-mouthpiece-type') == calculationName) {
        params = {
          _d1: $(this).data('d1-value'),
          __k: $(this).data('k-value'),
          _k1: $(this).data('k1-value'),
          _k2: $(this).data('k2-value'),
          _d2: $(this).data('d2-value')
        };
      }
    });
    result.first_match.match_percent = (((result.first_match.distance + parseFloat(params._d1 ))* parseFloat(params.__k ))+ parseFloat(params._d2 )).toFixed(2);
    result.second_match.match_percent = (((result.second_match.distance + parseFloat(params._d1 ))* parseFloat(params.__k ))+ parseFloat(params._d2 ) - (parseFloat(params._k1 )/100)).toFixed(2);
    result.third_match.match_percent = (((result.third_match.distance + parseFloat(params._d1 ))* parseFloat(params.__k ))+ parseFloat(params._d2 ) - (parseFloat(params._k2 )/100)).toFixed(2);
    if (debugMode) console.log(`%cfirst_match calculation - ${result.first_match.match_percent * 100}% ((d + d1) * k) + d2 : ( ${result.first_match.distance} + ${parseFloat(params._d1)} ) * ${parseFloat(params.__k)} ) + ${parseFloat(params._d2)}`, consolesecondary);
    if (debugMode) console.log(`%csecond_match calculation - ${result.second_match.match_percent * 100}% ((d + d1) * k) + d2 - (k1 / 100): ( ( ${result.second_match.distance} + ${parseFloat(params._d1)} ) * ${parseFloat(params.__k)} ) + ${parseFloat(params._d2)} - (${parseFloat(params._k1)}/100))`, consolesecondary);
    if (debugMode) console.log(`%cthird_match calculation - ${result.third_match.match_percent * 100}% ((d + d1) * k) + d2 - (k2 / 100): ( ( ${result.third_match.distance} + ${parseFloat(params._d1)} ) * ${parseFloat(params.__k)} ) + ${parseFloat(params._d2)} - (${parseFloat(params._k2)}/100))`, consolesecondary);
    if (debugMode) console.log('%cChoices ID: ' + choices, consoleprimary);
    if (debugMode) console.log('%cresult after match: ', consoleprimary);
    if (debugMode) console.log(result);
  }
    
  function show_match() {
    var customerIsLogged = $('#customerLogged').val() == 'true';
    if (debugMode) console.log('%ccustomer is Logged ? *************************' + customerIsLogged, consolesecondary);
    if (customerIsLogged === true) {
        var size = 0;
        var selectedMouthPiece =  localStorage.selected_col_item;
        $('.mouthpieces-questions').each(function(index) {
          if(selectedMouthPiece == $(this).data('for')){
            size = size + 1;
          }
        });
        if (debugMode) console.log('%csize : ' + size + ' - data skip count: ' + parseInt($('.excerpt-skip').attr('data-skipcount')), consolesecondary)
        if( size == parseInt($('.excerpt-skip').attr('data-skipcount')) ){
          if (debugMode) console.log('%cskip count if', '%c' + parseInt($('.excerpt-skip').attr('data-skipcount')), consolesecondary, consolesecondary )
          $('.step-2').hide();
          document.getElementById('my-aud1').pause();
          document.getElementById('my-aud2').pause();
          $('.step-4').show();
          $('.orientation-quiz-section .container').addClass('container--small');
          $('.orientation-quiz-section .container').removeClass('container--medium');
        }else{
            if (debugMode) console.log('%cskip count else' + parseInt($('.excerpt-skip').attr('data-skipcount')), consolesecondary)
        
            $('.match-percent-1').text((result.first_match.match_percent * 100).toFixed(0)+'%');
            $('.match-artist-1').text(result.first_match.name);
            $('.match-image-1').attr('src',result.first_match.featured_image);
            $('.match-desc-image-1').attr('src',result.first_match.desc_image);
            $('.match-info-btn-1').attr('href',result.first_match.product_url);
      
            $('.match-percent-2').text((result.second_match.match_percent * 100).toFixed(0)+'%');
            $('.match-artist-2').text(result.second_match.name);
            $('.match-image-2').attr('src',result.second_match.featured_image);
            $('.match-desc-image-2').attr('src',result.second_match.desc_image);
            $('.match-info-btn-2').attr('href',result.second_match.product_url);
            if((result.second_match.match_percent * 100)<70){
                $('.match-result-item-2').hide();
                $('.match-results').attr('data-matchresult',parseInt($('.match-results').attr('data-matchresult'))-1);
            }
  
            $('.match-percent-3').text((result.third_match.match_percent * 100).toFixed(0)+'%');
            $('.match-artist-3').text(result.third_match.name);
            $('.match-image-3').attr('src',result.third_match.featured_image);
            $('.match-desc-image-3').attr('src',result.third_match.desc_image);
            $('.match-info-btn-3').attr('href',result.third_match.product_url);
            if((result.third_match.match_percent * 100)<70){
                $('.match-result-item-3').hide();
                $('.match-results').attr('data-matchresult',parseInt($('.match-results').attr('data-matchresult'))-1);
            }
          
            $('.mouthpieces-questions').each(function(index) {
            if(selectedMouthPiece == $(this).data('for')){
                var handleQ1 = $(this).data('question1-system-handle');
                var toneQ1 = $(this).data('question1-tone');
                var powerQ1 = $(this).data('question1-power');
                var audioQ1 = $(this).data('question1-audio');
                var handleQ1 = $(this).data('question1-system-handle');
                var nameQ1 = $(this).data('question1-name').replace(' (' + selectedMouthPiece + ')', '');
                if($('.listened-excerpts-wrap .' + handleQ1).length <= 0 ){
                  $('.listened-excerpts-wrap').append(`<div class="listened-audio-item-wrap"><div class="player"><input type="checkbox" id="result_play_1st_${index}" 
                  class="play-pause" data-controlfor="result_audio_1st_${index}"> <label  class="custom_play_icon" for="result_play_1st_${index}"> 
                  <div class="play_pause_btn "> <div class="bar1"></div> <div class="bar2"></div> </div> </label><audio id="result_audio_1st_${index}" 
                  class="${handleQ1}" controls> <source class="listened-audio-item" 
                  src="${audioQ1}"> </audio>
                  <a class="custom_play_button">play / pause</a></div><div class="listened-audio-info">
                  <p>${nameQ1}</p>
                  <span>Tone : ${toneQ1} </span>
                  <span>Power : ${powerQ1} </span></div></div>`)
                }
                var handleQ2 = $(this).data('question2-system-handle');
                var toneQ2 = $(this).data('question2-tone');
                var powerQ2 = $(this).data('question2-power');
                var audioQ2 = $(this).data('question2-audio');
                var handleQ2 = $(this).data('question2-system-handle');
                var nameQ2 = $(this).data('question2-name').replace(' (' + selectedMouthPiece + ')', '');
                if($('.listened-excerpts-wrap .' + handleQ2).length <= 0 ){
                  $('.listened-excerpts-wrap').append(`<div class="listened-audio-item-wrap"><div class="player"><input type="checkbox" id="result_play_2nd_${index}" 
                  class="play-pause" data-controlfor="result_audio_2nd_${index}"> <label  class="custom_play_icon" for="result_play_2nd_${index}"> 
                  <div class="play_pause_btn "> <div class="bar1"></div> <div class="bar2"></div> </div> </label><audio id="result_audio_2nd_${index}" 
                  class="${handleQ2}" controls> <source class="listened-audio-item" 
                  src="${audioQ2}"> </audio>
                  <a class="custom_play_button">play / pause</a></div><div class="listened-audio-info">
                  <p>${nameQ2}</p>
                  <span>Tone : ${toneQ2} </span>
                  <span>Power : ${powerQ2} </span></div></div>`)
                }
            }
          });
          $('.step-2').hide();
          document.getElementById('my-aud1').pause();
          document.getElementById('my-aud2').pause();
          $('.orientation-quiz-section .container').removeClass('container--small');
          $('.orientation-quiz-section .container').addClass('container--medium');
          $('.step-3').show();
        }
    } else {
      if (debugMode) console.log('%ccookie null', consolesecondary)
      setCookie('o_result', JSON.stringify({first_match: result.first_match, second_match: result.second_match, third_match: result.third_match}),2);
      if (debugMode) console.log('%c' + JSON.stringify({first_match: result.first_match, second_match: result.second_match, third_match: result.third_match}), consolesecondary);
      if (debugMode) console.log('%c', result, consolesecondary);
      $('.step-2').hide();
      document.getElementById('my-aud1').pause();
      document.getElementById('my-aud2').pause();
      $('.orientation-quiz-section .container').removeClass('container--small');
      $('.orientation-quiz-section .container').addClass('container--medium');
      $('.step-5').show();
    }
  }
  
  function process_tp(mean_tone,mean_power,At,Ap,Bt,Bp,Ct,Cp){
    var processed_tone = ((mean_tone-At)*Bt)+Ct;
    var processed_power = ((mean_power-Ap)*Bp)+Cp;
    if (debugMode) console.log(`%cmean_tone: ${mean_tone} - At: ${At} - Bt: ${Bt} - Ct: ${Ct}`, consolesecondary);
    if (debugMode) console.log(`%cmean_power: ${mean_power} - Ap: ${Ap} - Bp: ${Bp} - Cp: ${Cp}`, consolesecondary);
    if (debugMode) console.log('%cprocessed_tone: ' + processed_tone + ' - processed_power: ' + processed_power, consoleprimary)
    get_closest_mouthpieces(processed_tone,processed_power);
    if (debugMode) console.log('%c1st match distance: ' + result.first_match.distance, consolesecondary);
    if (debugMode) console.log('%c2nd match distance: ' + result.second_match.distance, consolesecondary);
    if (debugMode) console.log('%c3rd match distance: ' + result.third_match.distance, consolesecondary);
    get_match_rate();
    if (debugMode) console.log('%cReminder ! processed_tone: ' + processed_tone + ' - processed_power: ' + processed_power, consoleprimary)
    if (debugMode) console.log(`%cfirst_match ${result.first_match.name} - ${result.first_match.match_percent * 100} %`, consoleprimary)
    if (debugMode) console.log(`%cfirst_match tone: ${result.first_match.tone} - power: ${result.first_match.power}`, consoleprimary)
    if (debugMode) console.log('%c****************************', consolesecondary);
    if (debugMode) console.log(`%csecond_match ${result.second_match.name} - ${result.second_match.match_percent * 100} %`, consoleprimary)
    if (debugMode) console.log(`%csecond_match tone: ${result.second_match.tone} - power: ${result.second_match.power}`, consoleprimary)
    if (debugMode) console.log('%c****************************', consolesecondary);
    if (debugMode) console.log(`%cthird_match ${result.third_match.name} - ${result.third_match.match_percent * 100} %`, consoleprimary)
    if (debugMode) console.log(`%cthird_match tone: ${result.third_match.tone} - power: ${result.third_match.power}`, consoleprimary)
    show_match();
  }
    
  $('.reload_quiz').on('click',function(){
   $('.loading_img_circle').show();
    eraseCookie('o_result');
    eraseCookie('mouthpiece_selected');
    setTimeout(function(){
      $('.section__header').show();
      $('.step-1').show();
      $('.orientation-quiz-section .container').removeClass('container--small');
      $('.orientation-quiz-section .container').addClass('container--medium');
      $('.step-3').hide();
       location.reload();
    },3000);
  });
   
  $('.set-customer-status').on('click',function(){
     localStorage.logged_in_for_result = "true";
     setCookie('show_result',location.href,2);
     setCookie('mouthpiece_selected',$('.collection-item[data-selected-mouthpiece="true"]').attr('data-mouthpiece-type'),2);
     setCookie('skip_count',parseInt($('.excerpt-skip').attr('data-skipcount')),2);
  })
    
  $('.collection-item[data-disabled="false"]').on('click',function(){
    localStorage.selected_col_item = $(this).attr('data-mouthpiece-type');
    $('.collection-item[data-disabled="false"]').removeClass('selected_col_item');
    $(this).addClass('selected_col_item');
      var selectedMouthPiece =  localStorage.selected_col_item;
      if (debugMode) console.log('%cnot disabled' + selectedMouthPiece, consolesecondary);
      var size = 0;
      $('.mouthpieces-questions').each(function(index) {
        if(selectedMouthPiece == $(this).data('for')){
          size = size + 1;
          if (debugMode) console.log('%cname is  ' + $(this).data('display_name_optional'), consolesecondary);
          //append progressbar li
          if(size == 1){
            $('.questions_progress_wrap .progressbar').append(`<li class='active'><span>Question `+size+` </span></li>`);
          }else{
            $('.questions_progress_wrap .progressbar').append(`<li><span>Question `+size+` </span></li>`);
          }
          if ($(this).data('index') == 1) {
            if (debugMode) console.log('%caudio1: ' + $(this).data('question1-audio'), consolesecondary)
            $('.audio-1').attr('src', $(this).data('question1-audio'));
            $('.audio-1').attr('tone', $(this).data('question1-tone'));
            $('.audio-1').attr('power', $(this).data('question1-power'));
            $('.audio-2').attr('src', $(this).data('question2-audio'));
            $('.audio-2').attr('tone', $(this).data('question2-tone'));
            $('.audio-2').attr('power', $(this).data('question2-power'));
            $('audio')[0].load();
            $('audio')[1].load();

             $(this).attr('data-selected-mouthpiece','true');
            $('.section__header').hide();
            $('.step-1').hide();
            $('.step-2').show();
            $('.orientation-quiz-section .container').removeClass('container--small');
            $('.orientation-quiz-section .container').addClass('container--medium');
          }
        }
      });
      $('.total_questions').text(size);

  });

  $('.excerpt-btn').on('mouseenter',function(){
      $(this).addClass('excerpt-hovered');
  })

  $('.excerpt-btn').on('mouseleave',function(){
      $(this).removeClass('excerpt-hovered');
  })
    
  $('.excerpt-btn').on('click',function(){
    // Remove play btn symbol after excert btn clicked
     $('.custom_play_button').removeClass('playing');
          
    $('.audio-1').attr('src','');
    $('.audio-2').attr('src','');
    $('audio')[0].load();
    $('audio')[1].load();
    $('audio')[0].currentTime = 0;
    $('audio')[1].currentTime = 0;
    $('audio')[0].pause();
    $('audio')[1].pause();
    $('.play-pause').prop('checked',false);
    setTimeout(function(){
        $('.excerpt-btn').removeClass('excerpt-hovered');
    },200)
    $('.questions_progress_wrap .progressbar .active').addClass('past');
    $('.questions_progress_wrap .progressbar .active + li').addClass('active');
    if($(this).hasClass('excerpt-1')){
      choices += '1';
      tone_arr.push(parseFloat( $('.audio-1').attr('tone')));
      power_arr.push(parseFloat( $('.audio-1').attr('power')));
      if (debugMode) console.log('%caudio1: ' + $('.audio-1').attr('src'), consolesecondary);
    }else if($(this).hasClass('excerpt-2')){
      tone_arr.push(parseFloat( $('.audio-2').attr('tone')));
      power_arr.push(parseFloat( $('.audio-2').attr('power')));
      if (debugMode) console.log('%caudio2: ' + $('.audio-2').attr('src'), consolesecondary);
      choices += '2';
    }else if($(this).hasClass('excerpt-skip')){
      $(this).attr('data-skipcount',parseInt($(this).attr('data-skipcount'))+1);
      tone_arr.push(parseFloat( $('.audio-2').attr('data-skip-tone')));
      power_arr.push(parseFloat( $('.audio-2').attr('data-skip-power')));
      choices += '3';
    }
    if (debugMode) console.log('%ctone array', consolesecondary);
    if (debugMode) console.log(tone_arr);
    if (debugMode) console.log('%cpower array', consolesecondary);
    if (debugMode) console.log(power_arr);
    question_index = question_index + 1;
    if (debugMode) console.log('%cquestion_index: ' + question_index, consolesecondary)
    
    var selectedMouthPiece = $('.selected_col_item').attr('data-mouthpiece-type');
    $('.mouthpieces-questions').each(function(index) {
        if(selectedMouthPiece == $(this).data('for')){
          if( question_index == $(this).data('index')){
            if (parseFloat($(this).data('at')) !== 0) {
              at = parseFloat($(this).data('at'));
            }
            if (parseFloat($(this).data('ap')) !== 0) {
              ap = parseFloat($(this).data('ap'));
            }
            if (parseFloat($(this).data('bp')) !== 0) {
              bp = parseFloat($(this).data('bp'));
            }
            if (parseFloat($(this).data('bt')) !== 0) {
              bt = parseFloat($(this).data('bt'));
            }
            if (parseFloat($(this).data('ct')) !== 0) {
              ct = parseFloat($(this).data('ct'));
            }
            if (parseFloat($(this).data('cp')) !== 0) {
              cp = parseFloat($(this).data('cp'));
            }
            if (debugMode) console.log('%c********** START ' + $(this).data('display_name_optional'), consoleprimary);
            if (debugMode) console.log(`%cAt: ${at} - Bt: ${bt} - Ct: ${ct}`, consolesecondary);
            if (debugMode) console.log(`%cAp: ${ap} - Bp: ${bp} - Cp: ${cp}`, consolesecondary);
            if (debugMode) console.log('%c********** END ' + $(this).data('display_name_optional'), consoleprimary);
            $('.audio-1').attr('src', $(this).data('question1-audio'));
            $('.audio-1').attr('tone', $(this).data('question1-tone'));
            $('.audio-1').attr('power', $(this).data('question1-power'));
            $('.audio-2').attr('src', $(this).data('question2-audio'));
            $('.audio-2').attr('tone', $(this).data('question2-tone'));
            $('.audio-2').attr('power', $(this).data('question2-power'));
            $('audio')[0].load();
            $('audio')[1].load();
            $('audio')[0].pause();
            $('audio')[1].pause();
          }
        }
    });
    if(parseInt($('.total_questions').text()) >= question_index  ){
      $('.curr-question').text(question_index);
    }
    if(parseInt($('.total_questions').text())+1 == question_index){
      process_tp(getMean(tone_arr),getMean(power_arr),at,ap,bt,bp,ct,cp);
    }
  })
                
  $('.listened-excerpts-wrap').on('change','.play-pause',function(){
    if (debugMode) console.log("listened-excerpts-wrap changed")
    if($(this).prop('checked')){
        if (debugMode) console.log('checked')
        $('#'+$(this).attr('data-controlfor'))[0].play();
    }else{
        if (debugMode) console.log('un checked')
        $('#'+$(this).attr('data-controlfor'))[0].pause();
    }
  });
  $('.play-pause').on('change',function(){
    if($(this).prop('checked')){
        if (debugMode) console.log('checked')
        $('#'+$(this).attr('data-controlfor'))[0].play();
    }else{
        if (debugMode) console.log('un checked')
        $('#'+$(this).attr('data-controlfor'))[0].pause();
    }
  });
};
  
  // Function to be called when changes occur on listened-excerpts-wrap
  var targetElement = document.querySelector('.listened-excerpts-wrap');
  
  function onDomSubtreeChange(mutationsList, observer) {
      // Call the function when the DOM subtree changes
      onAudioPlayClick();
  }
  
  var observerAP = new MutationObserver(onDomSubtreeChange);
  var observerConfig = { subtree: true, childList: true };
  // Start observing the target element for changes
  observerAP.observe(targetElement, observerConfig);
              
  // Audio play - pause btn
  var nyan = document.getElementById('nyan');
  var nyanBtn = document.getElementById('nyan-btn');
  function reset(btn, song){
     if(btn.classList.contains('playing')){
        btn.classList.toggle('playing');
     }
     song.pause();
     song.currentTime = 0;
  }
  
  function playPause(btn,song){
     for (let all_audios of document.querySelectorAll(".player")){
          $( all_audios).find('audio')[0].pause();
          $( all_audios).find('custom_play_button').toggleClass('playing');
           
          // if (debugMode) console.log($( all_audios).find('audio')[0])
        }
     if (song.paused && song.currentTime >= 0 && !song.ended) {
        song.play();
     } else {
        song.pause();
     }
  }
  
  function handleResponseValues() {
    if (debugMode) console.log('%c' + this.responseText, consolesecondary);
  }
  
  var baritoneItemstxt = $('#custommouthpieces-values').text();
  var baritoneItemsAdded = [];
  try {
    baritoneItemsAdded = JSON.parse(baritoneItemstxt);
  } catch(error) {
    if (debugMode) console.warn(error);
  }
  for (i = 0; i < baritoneItemsAdded.length; i++) {
     var node = baritoneItemsAdded[i].node;
     var fields = node.fields;
     var values = [];
     for (f = 0; f < fields.length; f++) {
       var key = fields[f].key;
       var value = fields[f].value;
       values[key] = value;
       if (key == 'product' && fields[f].reference && fields[f].reference.onlineStoreUrl) {
         values[key] = fields[f].reference.onlineStoreUrl;
       } else if (key == "featured_image" || key == "description_image") {
         values[key] = fields[f].reference.image.url;
       }
     }

    if (values['for'] !== 'alto' && values['for'] !== 'tenor') {
      if ($(`[data-id="${values['name']}-${values['for']}"]`).length <= 0) {
        $('#mouthpieces-values').append(`<span class="mouthpieces-values" 
          data-id="${values['name']}-${values['for']}" 
          data-name="${values['name']}" 
          data-featured_image="${values['featured_image']}"
          data-description_image="${values['description_image']}"
          data-tone="${values['tone']}"
          data-power="${values['power']}"
          data-for="${values['for']}"
          data-product="${values['product']}"
        ></span>`);
      }
    }
  }
  
  function progress(btn, song){
     setTimeout(function(){
        var end = song.duration; 
        var current = song.currentTime;
        var percent = current/(end/100);
        //check if song is at the end
        if(current==end){
           reset(btn, song);
        }
        //set inset box shadow
        btn.style.boxShadow = "inset " + btn.offsetWidth * (percent/100) + "px 0px 0px 0px rgba(0,0,0,0.125)"
        //call function again
        progress(btn, song);     
     }, 133.7);
  }  
  function onAudioPlayClick(){
    $('body').on('click','.custom_play_button',function(e){
      e.preventDefault();
      if ($(this).prev()[0].paused == false) {
        $(this).prev().trigger('pause');
      } else {
        $('audio').trigger('pause');
        $(this).prev().trigger('play');
      }
      
      $('.custom_play_button').not($(this)).removeClass('playing');
      $(this).toggleClass('playing');
       // playPause($(this)[0],$(this).prev()[0]);
       progress($(this)[0], $(this).prev()[0]);
      
       if( $(this).closest('.listened-audio-item-wrap').length > 0){
           if(!$(this).prev()[0].paused()){
               // if (debugMode) console.log("playing");
               $(this).prev()[0].pause();
          } else {
              playPause($(this)[0],$(this).prev()[0]);
             // $(this).prev()[0].play();
             $(this).addClass('playing');
          }
       } 
    });
  }
  onAudioPlayClick();


  } catch(e) { console.error(e); }
})();
})();
